import { useEffect } from 'react';
import { IFPGrowthParameters } from './fp-growth-interfaces';
import { useFPGrowthStore } from './dal/fp-growth-store';
import FpGrowthView from './ui/fp-growth-view';
import FPGrowthParameters from './ui/fp-growth-parameters';

const initialParameters: IFPGrowthParameters = {
    "rows": [
        ["n","l","k"],
        ["n","l"],
        ["n","c","f"],
        ["f","c"],
        ["f","k"],
        ["n","c","f"]
    ],
    "minSupport": 0.3334,
    "minConfidence": 0.6
};

const FPGrowthHome = () => {

    const params = useFPGrowthStore(store => store.params);
    const setParams = useFPGrowthStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">FPGrowth</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <FPGrowthParameters />
                        <FpGrowthView />
                    </div>
                }
            </div>

        </div>
    )
};

export default FPGrowthHome;
